import { createAsyncThunk } from '@reduxjs/toolkit';
import doFetch from 'utils/api/doFetch';

import type {
  AssignDevicesToMemberResponseType,
  OrganizationId,
  RemoveMemberFromOrgRequestBody,
} from 'redux-store/slices/organizationOverview/types';

const removeMembersFromOrganizationThunk = createAsyncThunk(
  'organizationOverview/removeMembersFromOrganization',
  async ({
    organizationId,
    data,
  }: {
    organizationId: OrganizationId;
    data: RemoveMemberFromOrgRequestBody;
  }): Promise<AssignDevicesToMemberResponseType> => {
    try {
      const apiPointName = 'removeMembersFromOrganization';

      return await doFetch<typeof apiPointName>({
        apiPointName,
        body: data,
        urlParams: { organizationId },
      });
    } catch (e) {
      return Promise.reject(e);
    }
  },
);

export default removeMembersFromOrganizationThunk;
